import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FirebaseService } from './firebase.service';
import { mergeMap } from 'rxjs';
import { PaymentStatus } from './payments.service';

type DesktopPaymentDetailsResponse = {
  payment_details: DesktopPaymentDetails;
};

export type DesktopPaymentDetails = {
  desktop_payment: DesktopPayment;
  payment_method: string;
  transactions: AuthorizeNetTransaction[];
};

export type DesktopPayment = {
  id: string;
  desktop_invoice_id: string;
  completed: boolean;
  status: PaymentStatus;
  status_description: string;
  created_at: string;
  updated_at: string;
};

export type DesktopPaymentResponse = {
  desktop_payment: DesktopPayment;
};

export type AuthorizeNetTransaction = {
  id: string;
  ref_id: string;
  amount: number;
  auto_payment: boolean;
  create_transaction_request: any;
  completed: boolean;
  transaction_response: any;
  trans_id: string;
  commit_response: any;
  desktop_payment_id: string;
  created_at: string;
  created_by: string;
  updated_at: string;
};

@Injectable({
  providedIn: 'root',
})
export class DesktopPaymentsService {
  getPaymentDetailsByInvoiceIdUrl =
    environment.serverUrl + '/desktop-payments/get-for-invoice';

  constructor(
    private http: HttpClient,
    private firebaseService: FirebaseService
  ) {}

  getDesktopPaymentDetails(invoiceId: string) {
    return this.firebaseService.idToken().pipe(
      mergeMap((token) => {
        return this.http.get<DesktopPaymentDetailsResponse>(
          `${this.getPaymentDetailsByInvoiceIdUrl}/${invoiceId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      })
    );
  }

  isSuccessfulAuthorizeNetTransaction(
    transaction: AuthorizeNetTransaction
  ): boolean {
    if (!transaction.completed) {
      return false;
    }
    if (!transaction.trans_id) {
      return false;
    }
    const responseCode =
      transaction.transaction_response?.transactionResponse?.responseCode;
    return responseCode === '1';
  }

  getSuccessfulAuthorizeNetTransaction(
    transactions: AuthorizeNetTransaction[]
  ): AuthorizeNetTransaction | undefined {
    let successful: AuthorizeNetTransaction | undefined;
    for (const transaction of transactions) {
      if (this.isSuccessfulAuthorizeNetTransaction(transaction)) {
        successful = transaction;
      }
    }
    return successful;
  }
}
